import { render, staticRenderFns } from "./AtomButton.vue?vue&type=template&id=1028a23c&scoped=true"
import script from "./AtomButton.vue?vue&type=script&lang=ts"
export * from "./AtomButton.vue?vue&type=script&lang=ts"
import style0 from "./AtomButton.vue?vue&type=style&index=0&id=1028a23c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1028a23c",
  null
  
)

export default component.exports